"use strict";

exports.__esModule = true;
exports.IconsBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = require("styled-components");
var _VimanaIcon = require("../../VimanaIcon");
var _StripeChartTooltipDate = require("./StripeChartTooltipDate");
var _User = require("../../User");
var _utils = require("./utils");
var _styles = require("./styles");
var _helpers = require("../../InstantaneousEvent/helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DATE_FORMAT = "MMM D, hh:mm A";
var showId = function showId(eventType) {
  return eventType === _helpers.InstantaneousEventTickets;
};
function getIconTooltipContent(args) {
  var icon = args.icon,
    description = args.description,
    height = args.height,
    id = args.id,
    created = args.created,
    theme = args.theme,
    username = args.username,
    eventType = args.eventType;
  return /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipContent, {
    "data-testid": "IconTooltipContent"
  }, /*#__PURE__*/_react["default"].createElement(_styles.EventIconContainer, null, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
    icon: icon,
    iconSize: height * 1.25,
    alt: icon,
    margin: "3px 0 0 0"
  })), /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipContentHeader, null, username ? /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipUsername, {
    "data-testid": "IconTooltipUsername"
  }, username) : null, id && showId(eventType) ? /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipId, {
    "data-testid": "IconTooltipId"
  }, "#", id) : null), /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipContentDescription, {
    "data-testid": "IconTooltipContentDescription"
  }, description), /*#__PURE__*/_react["default"].createElement(_StripeChartTooltipDate.StripeChartTooltipDate, {
    timeInMs: created,
    format: DATE_FORMAT,
    style: {
      fontSize: theme.fontSizeXXXS,
      gridArea: "date",
      padding: "4px 4px 0 8px",
      color: theme.TooltipContentColor
    }
  }));
}
var IconsBar = exports.IconsBar = (0, _styledComponents.withTheme)(function (props) {
  var height = props.height,
    width = props.width,
    instantaneousEventList = props.instantaneousEventList,
    scale = props.scale,
    theme = props.theme;
  var users = _react["default"].useContext(_User.UserListContext);
  var _useState = (0, _react.useState)(""),
    activeEventId = _useState[0],
    setActiveEventId = _useState[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: width,
      height: height
    },
    "data-testid": "IconsBar"
  }, instantaneousEventList.map(function (_ref) {
    var icon = _ref.icon,
      created = _ref.created,
      description = _ref.description,
      id = _ref.id,
      creatorId = _ref.creatorId,
      eventType = _ref.eventType;
    var username = (0, _utils.getFormattedUserName)(creatorId, users, eventType);
    var leftDistance = scale(created);
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "IconEventDiv-" + icon + "-" + id,
      key: icon + "-" + id,
      onMouseEnter: function onMouseEnter() {
        setActiveEventId(icon + "-" + id);
      },
      onMouseLeave: function onMouseLeave() {
        setActiveEventId("");
      },
      style: {
        position: "absolute",
        left: leftDistance + "px"
      }
    }, activeEventId === icon + "-" + id ? /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      popoverClassName: ["chart-tooltip"],
      isOpen: activeEventId === icon + "-" + id,
      position: leftDistance > width / 2 ? _core.Position.BOTTOM_RIGHT : _core.Position.BOTTOM_LEFT,
      content: getIconTooltipContent({
        icon: icon,
        description: description,
        height: height,
        id: id,
        created: created,
        theme: theme,
        username: username,
        eventType: eventType
      })
    }, /*#__PURE__*/_react["default"].createElement("div", null)) : null, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
      icon: icon,
      iconSize: height,
      alt: icon,
      margin: "0px 0px 0px -7px"
    }));
  }));
});